export default {
    LOAD_EXPENSES (state, expenses) {
        state.items = expenses
    }
}